import React from "react";
// import aboutcontent from "../../images/about/about-content.svg";
import send from "../../images/blockchain/sing-btn.svg";
import Signin from "../../images/blockchain/singin.svg";

const BlockContentTwo = (props) => {
  return (
    <section
      id="id_ico_about_section "
      className={`ico_about_section section_space section_decoration bg-white pt-0 ${props.abClass}`}
    >
      <div className="container">
        <div className="row justify-content-lg-between align-items-center">
          <div className="col-lg-6">
            <div className="px-4">
              <img src={Signin} alt="About" />
            </div>
          </div>
          <div className="col-lg-6 d-lg-flex flex-lg-column gap-3">
            <div>
              {/* <h2 className="heading_text text-dark py-4 text-start mb-0">
                After signing up and receiving your unique number, please follow
                the steps below to collect your free TopCoin UK units:
              </h2> */}
              <p className="info_description opacity-50 text-dark mb-0">
                1. Each product has a TopCoin UK logo, carefully remove it. On
                the back of the logo, you will find a set of unit numbers.
              </p>
              <p className="info_description opacity-50 text-dark mb-0">
                2. To claim your free TopCoin, send us these numbers in the
                correct format: • Write your unique number, followed by a dash
                (-), then list all the unit{" "}
              </p>
              <p className="info_description opacity-50 text-dark mb-0">
                3. Send the formatted numbers to our email: info@topcoinuk.com
              </p>
            </div>

            <div className="border-top py-3">       

              <p className="info_description opacity-50 text-dark mb-0">
                Make sure to include all numbers behind the logo. Once received,
                we will add the corresponding TopCoin to your account.
              </p>
              <div className="d-flex gap-2 py-3 align-items-center">
                <div className="">
                  <img src={send} width={48} className="" alt="" />
                </div>
                <div>
                  <p className="mb-0 text-uppercase text-dark opacity-75">
                    Send all numbers to:
                  </p>
                  <h5 className="text-dark opacity-75 mb-0">
                    {" "}
                    info@topcoinuk.com
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlockContentTwo;
